import React from "react";
import Box from "@mui/material/Box";
import { Checkbox } from "@metacrm/metacrm-material-ui/dist/Checkbox";
import {
  StyledModeContainer,
  StyledModeTitle,
  StyledModeDescription,
  StyledDefaultLabel,
} from "./TicketType.styles";
import { useIntl } from "react-intl";

const TicketCreationMode = ({
  ticketCreationMode,
  onTicketCreationModeChange,
  canEdit = true,
}) => {
  const { formatMessage } = useIntl();

  const handleModeChange = (mode) => {
    if (canEdit && onTicketCreationModeChange) {
      onTicketCreationModeChange(mode);
    }
  };

  return (
    <Box mt="24px" display="flex" gap="24px">
      {/* Report Form Mode */}
      <StyledModeContainer
        isSelected={ticketCreationMode === "form"}
        canEdit={canEdit}
        onClick={() => handleModeChange("form")}
      >
        <Box display="flex" alignItems="flex-start" gap="16px">
          <Checkbox
            checked={ticketCreationMode === "form"}
            onChange={() => handleModeChange("form")}
            disabled={!canEdit}
          />
          <Box>
            <StyledModeTitle>
              {formatMessage({
                id: "ticketSetting.creationMode.formMode.title",
              })}
              <StyledDefaultLabel>
                ({formatMessage({ id: "global.commonWords.default" })})
              </StyledDefaultLabel>
            </StyledModeTitle>
            <StyledModeDescription>
              {formatMessage({
                id: "ticketSetting.creationMode.formMode.description",
              })}
            </StyledModeDescription>
          </Box>
        </Box>
      </StyledModeContainer>

      {/* Real-time Chat Mode */}
      <StyledModeContainer
        isSelected={ticketCreationMode === "chat"}
        canEdit={canEdit}
        onClick={() => handleModeChange("chat")}
      >
        <Box display="flex" alignItems="flex-start" gap="16px">
          <Checkbox
            checked={ticketCreationMode === "chat"}
            onChange={() => handleModeChange("chat")}
            disabled={!canEdit}
          />
          <Box>
            <StyledModeTitle>
              {formatMessage({
                id: "ticketSetting.creationMode.chatMode.title",
              })}
            </StyledModeTitle>
            <StyledModeDescription>
              {formatMessage({
                id: "ticketSetting.creationMode.chatMode.description",
              })}
            </StyledModeDescription>
          </Box>
        </Box>
      </StyledModeContainer>
    </Box>
  );
};

export default TicketCreationMode;
